import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

/**
 * Figure component.
 * @since 0.0.42
 */
var Figure = function Figure(_ref) {
  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      href = _ref.href,
      caption = _ref.caption,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className", "href", "caption", "children"]);

  return React.createElement("figure", _extends({
    className: classNames(baseClassName, className)
  }, props), children, href && React.createElement("a", {
    href: href,
    className: classNames("".concat(baseClassName, "__overlay"), "".concat(baseClassName, "__overlay--cover"), "".concat(baseClassName, "__action"))
  }), caption && React.createElement("figcaption", {
    className: classNames("".concat(baseClassName, "__overlay"), "".concat(baseClassName, "__overlay--bottom"))
  }, caption));
};

Figure.propTypes = {
  /**
   * @since 0.0.47
   */
  href: PropTypes.string,

  /**
   * @since 0.0.47
   */
  caption: PropTypes.any,

  /**
   * Content of the figure
   * @since 0.0.42
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  baseClassName: PropTypes.string
};
Figure.defaultProps = {
  href: null,
  caption: null,
  children: null,
  className: null,
  baseClassName: "".concat(CLS_PREFIX, "figure")
};
export default Figure;